/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDispatch, useSelector } from 'react-redux';
import { redirectAfterPublishDefault, updatePublishDate, updatePublishImmediately, trackPublish, updateOriginalPublishDate, showPublishErrors
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/publishActions';
import { getPublishDate, getShouldPublishImmediately, getOriginalPublishDate, getSubcategory, getContentModelId
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error Untyped module
import { getPublishType } from 'ContentEditorUI/redux/selectors/publishSelectors';
import I18n from 'I18n';
import { useCallback, useContext } from 'react';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { fetchContent, fetchHardSavedContent
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/contentActions';
import { getIsLandingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getShouldOpenPostPublishCustomDomainSetupModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
// @ts-expect-error Untyped module
import { publish } from 'page-editor-ui/redux/actions/pagePublishActions';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { markActionComplete } from 'user-context/onboarding';
// @ts-expect-error Untyped module
import { PAGES_API_BASE_URL } from 'page-editor-ui/Constants';
// @ts-expect-error Untyped module
import { showThrottledPostPagePublishCsatSurvey } from 'ContentEditorUI/lib/csatSurvey';
import { getIsPublishingNotUpdating, getIsSchedulingNotUpdating
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/publishSelectors';
// @ts-expect-error Untyped module
import { getIsAdvancedPageTemplateOrHasAdvancedFeaturesAccess } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { getContentModelDynamicPageSourceValue, getDynamicPageSourceType
// @ts-expect-error Untyped module
} from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
// @ts-expect-error Untyped module
import { getIsSchedulingUpdate } from 'page-editor-ui/redux/selectors/pagePublishSelectors';
import { displayPublishSuccessAlert } from 'ContentEditorUI/utils/displayPublishSuccessAlert';
// @ts-expect-error Untyped module
import { getPageSettingsFullUrl } from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
// @ts-expect-error Untyped module
import { togglePostPublishDomainSetupModal } from 'ContentEditorUI/redux/actions/appActions';
import { PublishTypes } from 'ContentEditorUI/constants/PublishTypes';
import useOneClickPublishTour from 'ContentEditorUI/hooks/useOneClickPublishTour';
import { isFromPaymentsGuide } from 'payments-post-enroll-local-storage-lib/data/onboardingTours';
import { getActiveDomainIsConnected, getActiveDomainIsInternal } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
// @ts-expect-error Untyped module
import { getHasAnyLayoutSections } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
// @ts-expect-error Untyped module
import { getBaseApiUrl } from 'ContentEditorUI/redux/selectors/extraInitialStateSelectors';
import { getBaseContentUrl, fetch as fetchContentApi
// @ts-expect-error Untyped module
} from 'ContentEditorUI/api/ContentApi';
// @ts-expect-error Untyped module
import PublishApi from 'ContentEditorUI/api/PublishApi';
// @ts-expect-error Untyped module
import { save as saveAction } from '../redux/actions/pageSaveActions';
import { jsx as _jsx } from "react/jsx-runtime";
const HIDE_TASK_COMPLETION_MODAL = {
  showTaskCompletionModal: false
};
const showPagesCsatSurvey = (isPublishingNotUpdating, isSchedulingNotUpdating, notStarterCustomerish) => {
  const isPublishingOrScheduling = isPublishingNotUpdating || isSchedulingNotUpdating;

  // Only show the survey to pages that were just published/scheduled (not updated)
  // ... and _not_ to customers in the LP starter beta (using a page from a starter template)
  if (isPublishingOrScheduling && notStarterCustomerish) {
    showThrottledPostPagePublishCsatSurvey();
  }
};
const redirectAfterPublish = isLandingPage => defaultRedirectParams => {
  return Promise.all([markActionComplete('explore-publish-site', HIDE_TASK_COMPLETION_MODAL), markActionComplete('page-editor-demo', HIDE_TASK_COMPLETION_MODAL), isLandingPage && markActionComplete('publish-landing-page', HIDE_TASK_COMPLETION_MODAL)]).catch(e => console.error(e)).finally(() => redirectAfterPublishDefault(defaultRedirectParams));
};

// Configured to only work with unified publish button setup
export const usePublishLifecycleHandlers = () => {
  const {
    tour
  } = useContext(TourContext);
  const dispatch = useDispatch();
  const isLandingPage = useSelector(getIsLandingPage);
  const isPublishingNotUpdating = useSelector(getIsPublishingNotUpdating);
  const isSchedulingNotUpdating = useSelector(getIsSchedulingNotUpdating);
  const notStarterCustomerish = useSelector(getIsAdvancedPageTemplateOrHasAdvancedFeaturesAccess);
  const dynamicPagesSource = useSelector(getDynamicPageSourceType);
  const dynamicPagesSourceValue = useSelector(getContentModelDynamicPageSourceValue);
  const isSchedulingUpdate = useSelector(getIsSchedulingUpdate);
  const pageSettingsFullUrl = useSelector(getPageSettingsFullUrl);
  const shouldOpenPostPublishCustomDomainSetupModal = useSelector(getShouldOpenPostPublishCustomDomainSetupModal);
  const domainIsConnected = useSelector(getActiveDomainIsConnected);
  const domainIsInternal = useSelector(getActiveDomainIsInternal);
  const isDndPage = useSelector(getHasAnyLayoutSections);
  const originalPublishDate = useSelector(getOriginalPublishDate);
  const categoryId = useSelector(getCategoryId);
  const appState = useSelector(state => state);
  const contentId = useSelector(getContentModelId);
  const publishType = isSchedulingNotUpdating ? PublishTypes.schedule : isPublishingNotUpdating ? PublishTypes.publish : PublishTypes.update;

  // TODO: to be replaced with CMP API in near future
  const baseContentUrl = getBaseContentUrl({
    baseUrl: useSelector(getBaseApiUrl),
    categoryId,
    subcategory: useSelector(getSubcategory),
    contentId
  });
  const endTourIfAny = () => {
    if (tour && tour.getStep() === 'publish') {
      tour.finish();
    }
  };
  const publishUnpublishAPICallback = isUnpublish => {
    return PublishApi.publish({
      baseContentUrl,
      timeout: 20000,
      unpublish: isUnpublish
    });
  };
  const refetchContent = () => {
    const params = {
      baseUrl: PAGES_API_BASE_URL
    };
    dispatch(fetchContent(params));
    dispatch(fetchHardSavedContent(params));
  };
  const onPublishSuccess = () => {
    markActionComplete('explore-publish-site');
    markActionComplete('page-editor-demo', HIDE_TASK_COMPLETION_MODAL);
    if (isLandingPage) {
      markActionComplete('publish-landing-page');
    }

    // TODO: Remove when API is updated so that publish-action returns the publishDate.
    // This is temp workaround to sync publishDate in FE state with BE after a publish.
    // We need this because publish-action updates publishDate AFTER our final pre-publish save request.
    fetchContentApi(baseContentUrl).then(({
      publishDate
    }) => {
      if (publishDate) {
        dispatch(updatePublishDate(publishDate));
        if (!originalPublishDate) {
          dispatch(updateOriginalPublishDate(publishDate));
        }
      }
    }).catch();
    if (shouldOpenPostPublishCustomDomainSetupModal && publishType === PublishTypes.publish) {
      dispatch(togglePostPublishDomainSetupModal(true));
    } else if (!isFromPaymentsGuide()) {
      // Do not display UI Alert banner if in payments guided tour since we will display a modal instead
      displayPublishSuccessAlert({
        contentType: 'page',
        publishType,
        publishedContentUrl: pageSettingsFullUrl
      });
    }
    showPagesCsatSurvey(isPublishingNotUpdating, isSchedulingNotUpdating, notStarterCustomerish);
    refetchContent();
  };
  const onUnpublishSuccess = () => {
    refetchContent();
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.message"
      }),
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.text"
      }),
      type: 'success'
    });
  };
  const trackPublishEvent = isSuccessful => {
    trackPublish({
      contentId,
      isConnectedAndCustomDomain: domainIsConnected && !domainIsInternal,
      isDndPage,
      publishType,
      usageTrackingProperties: {
        dynamicPagesSource,
        dynamicPagesSourceValue,
        isSchedulingUpdate
      },
      isSuccessful
    });
  };
  const onPublishError = errorResponse => {
    showPublishErrors(errorResponse.responseJSON || {}, categoryId, appState);
  };
  const onUnpublishError = errorResponse => {
    showPublishErrors(errorResponse.responseJSON || {}, categoryId, appState);
  };
  return {
    saveAction,
    endTourIfAny,
    publishUnpublishAPICallback,
    onPublishSuccess,
    onPublishError,
    onUnpublishSuccess,
    onUnpublishError,
    trackPublishEvent
  };
};
const usePublishAction = () => {
  const {
    tour
  } = useContext(TourContext);
  const publishType = useSelector(getPublishType);
  const shouldPublishImmediately = useSelector(getShouldPublishImmediately);
  const publishDate = useSelector(getPublishDate);
  const dispatch = useDispatch();
  const isLandingPage = useSelector(getIsLandingPage);
  const isPublishingNotUpdating = useSelector(getIsPublishingNotUpdating);
  const isSchedulingNotUpdating = useSelector(getIsSchedulingNotUpdating);
  const notStarterCustomerish = useSelector(getIsAdvancedPageTemplateOrHasAdvancedFeaturesAccess);
  const dynamicPagesSource = useSelector(getDynamicPageSourceType);
  const dynamicPagesSourceValue = useSelector(getContentModelDynamicPageSourceValue);
  const isSchedulingUpdate = useSelector(getIsSchedulingUpdate);
  const pageSettingsFullUrl = useSelector(getPageSettingsFullUrl);
  const shouldOpenPostPublishCustomDomainSetupModal = useSelector(getShouldOpenPostPublishCustomDomainSetupModal);
  const {
    startOneClickPublishTour
  } = useOneClickPublishTour();
  return useCallback((skipPublishRedirect = false) => {
    if (tour && tour.getStep() === 'publish') {
      tour.finish();
    }
    if (publishType === 'publish' && (shouldPublishImmediately || !publishDate)) {
      // save current time as publishDate if value
      // isn't already set before publishing or if publishing immediately
      dispatch(updatePublishImmediately(true));
      dispatch(updatePublishDate(I18n.moment.portalTz().valueOf()));
    }
    dispatch(publish({
      skipPublishRedirect,
      redirectAfterPublish: redirectAfterPublish(isLandingPage),
      onPublishSuccess: () => {
        if (skipPublishRedirect) {
          markActionComplete('explore-publish-site');
          markActionComplete('page-editor-demo', HIDE_TASK_COMPLETION_MODAL);
          if (isLandingPage) {
            markActionComplete('publish-landing-page');
          }
          const params = {
            baseUrl: PAGES_API_BASE_URL
          };
          if (shouldOpenPostPublishCustomDomainSetupModal && publishType === PublishTypes.publish) {
            dispatch(togglePostPublishDomainSetupModal(true));
          } else {
            if (!isFromPaymentsGuide()) {
              // Do not display UI Alert banner if in payments guided tour since we will display a modal instead
              displayPublishSuccessAlert({
                contentType: 'page',
                publishType,
                publishedContentUrl: pageSettingsFullUrl
              });
            }
            startOneClickPublishTour();
          }
          showPagesCsatSurvey(isPublishingNotUpdating, isSchedulingNotUpdating, notStarterCustomerish);
          dispatch(fetchContent(params));
          dispatch(fetchHardSavedContent(params));
        }
      },
      usageTrackingProperties: {
        dynamicPagesSource,
        dynamicPagesSourceValue,
        isSchedulingUpdate
      },
      // TODO: Temporary increase in timeout to unblock customers with publishing issues
      timeout: 20000
    }));
  }, [tour, publishType, shouldPublishImmediately, publishDate, dispatch, isLandingPage, dynamicPagesSource, dynamicPagesSourceValue, isSchedulingUpdate, isPublishingNotUpdating, isSchedulingNotUpdating, notStarterCustomerish, shouldOpenPostPublishCustomDomainSetupModal, pageSettingsFullUrl, startOneClickPublishTour]);
};
export default usePublishAction;